import { Component, OnInit } from '@angular/core';
import { BannerPositionListViewModel } from '../shared/models/banner-position-list-view-model';
import { SettingsService } from '../shared/services/settings.service';

@Component({
  selector: 'app-ads-manage-page',
  templateUrl: './ads-manage-page.component.html',
  styleUrls: ['./ads-manage-page.component.less'],
  standalone: false,
})
export class AdsManagePageComponent implements OnInit {
  public bannerPositions: BannerPositionListViewModel;
  public headBannerPositions: number[];

  constructor(private settingsService: SettingsService) {}

  ngOnInit() {
    this.loadBannerPositionData();
  }

  public loadBannerPositionData() {
    this.settingsService.loadBannerPagePositionList().subscribe((data) => {
      this.bannerPositions = data;
      // this.headBannerPositions = Object.keys(this.bannerPositions.bannerPositions);
    });
  }
}
